// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_3jpT","tooltipText":"_111Q"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Chart/DiagonalLine/Step/Tooltip/styles.scss
// module id = 452
// module chunks = 0